<div class="page pickup-board-page">
  <div class="page-header">
    <div>
      <h1>{{ 'PICKUP.BOARD_TITLE' | translate }}</h1>
      <p class="page-subtitle">
        {{ 'PICKUP.BOARD_SUBTITLE' | translate }}
        <span *ngIf="date"> · {{ date }}</span>
      </p>
    </div>
    <div class="page-actions">
      <button type="button" class="btn btn-secondary" (click)="refresh()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        {{ 'PICKUP.REFRESH' | translate }}
      </button>
      <button type="button" class="btn btn-primary" *ngIf="!isTeacher" (click)="openScanner()">
        <mat-icon>qr_code_scanner</mat-icon>
        {{ 'PICKUP.OPEN_SCANNER' | translate }}
      </button>
    </div>
  </div>

  <div class="board-toolbar">
    <div class="form-field class-field">
      <label>{{ 'PICKUP.CLASS' | translate }}</label>
      <app-searchable-select
        [(ngModel)]="selectedClassId"
        [options]="classOptions"
        [placeholder]="'PICKUP.SELECT_CLASS' | translate"
        [allowEmpty]="false"
        (selectionChange)="onClassChange($event)"
      ></app-searchable-select>
    </div>
    <div class="board-stats">
      <span class="stat waiting">
        <strong>{{ waiting.length }}</strong>
        {{ 'PICKUP.WAITING' | translate }}
      </span>
      <span class="stat buses">
        <strong>{{ (allBusesReady ? 1 : 0) + buses.length }}</strong>
        {{ 'PICKUP.BUSES' | translate }}
      </span>
      <span class="stat collected">
        <strong>{{ collected.length }}</strong>
        {{ 'PICKUP.COLLECTED' | translate }}
      </span>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>

  <div class="board-loading" *ngIf="loading">{{ 'PICKUP.LOADING' | translate }}</div>

  <div class="board-columns" *ngIf="!loading">
    <section class="board-section board-column">
      <header class="section-head buses-head">
        <h2>{{ 'PICKUP.BUSES_SECTION' | translate }}</h2>
        <p>{{ 'PICKUP.BUSES_HINT' | translate }}</p>
      </header>

      <div class="cards-grid" *ngIf="orderedBusCards.length; else emptyBuses">
        <article
          class="pickup-card bus"
          [class.all-ready]="card.kind === 'all-ready'"
          *ngFor="let card of orderedBusCards"
        >
          <div class="card-status">{{ 'PICKUP.STATUS_BUS' | translate }}</div>
          <ng-container *ngIf="card.kind === 'all-ready'">
            <h3 class="student-name">{{ 'PICKUP.ALL_BUSES_READY' | translate }}</h3>
            <p class="time-line" *ngIf="card.waitingAt">
              <mat-icon>schedule</mat-icon>
              <span>{{ formatTime(card.waitingAt) }}</span>
            </p>
          </ng-container>
          <ng-container *ngIf="card.kind === 'bus'">
            <h3 class="student-name">{{ busLabel(card.item) }}</h3>
            <p class="meta" *ngIf="card.item.bus?.driverName">{{ card.item.bus?.driverName }}</p>
            <p class="meta" *ngIf="card.item.bus?.plateNumber">{{ card.item.bus?.plateNumber }}</p>
            <p class="time-line" *ngIf="card.waitingAt">
              <mat-icon>schedule</mat-icon>
              <span>{{ formatTime(card.waitingAt) }}</span>
            </p>
          </ng-container>
        </article>
      </div>
      <ng-template #emptyBuses>
        <div class="empty-state">{{ 'PICKUP.EMPTY_BUSES' | translate }}</div>
      </ng-template>
    </section>

    <section class="board-section board-column">
      <header class="section-head waiting-head">
        <h2>{{ 'PICKUP.WAITING_SECTION' | translate }}</h2>
        <p>{{ 'PICKUP.WAITING_HINT' | translate }}</p>
      </header>

      <div class="cards-grid" *ngIf="waiting.length; else emptyWaiting">
        <article
          class="pickup-card waiting clickable"
          *ngFor="let item of waiting"
          role="button"
          tabindex="0"
          (click)="openCollectConfirm(item)"
          (keydown.enter)="openCollectConfirm(item)"
          (keydown.space)="$event.preventDefault(); openCollectConfirm(item)"
        >
          <div class="card-status">{{ 'PICKUP.STATUS_WAITING' | translate }}</div>
          <h3 class="student-name">{{ displayName(item.student) }}</h3>
          <p class="meta" *ngIf="item.student?.class?.name || item.class?.name">
            {{ item.student?.class?.name || item.class?.name }}
          </p>
          <p class="parent-line">
            <mat-icon>family_restroom</mat-icon>
            <span>{{ displayName(item.parent) }}</span>
          </p>
          <p class="time-line" *ngIf="item.waitingAt">
            <mat-icon>schedule</mat-icon>
            <span>{{ formatTime(item.waitingAt) }}</span>
          </p>
        </article>
      </div>
      <ng-template #emptyWaiting>
        <div class="empty-state">{{ 'PICKUP.EMPTY_WAITING' | translate }}</div>
      </ng-template>
    </section>

    <section class="board-section board-column">
      <header class="section-head collected-head">
        <h2>{{ 'PICKUP.COLLECTED_SECTION' | translate }}</h2>
        <p>{{ 'PICKUP.COLLECTED_HINT' | translate }}</p>
      </header>

      <div class="cards-grid" *ngIf="collected.length; else emptyCollected">
        <article class="pickup-card collected" *ngFor="let item of collected">
          <div class="card-status">{{ 'PICKUP.STATUS_COLLECTED' | translate }}</div>
          <h3 class="student-name">{{ displayName(item.student) }}</h3>
          <p class="meta" *ngIf="item.student?.class?.name || item.class?.name">
            {{ item.student?.class?.name || item.class?.name }}
          </p>
          <p class="parent-line">
            <mat-icon>family_restroom</mat-icon>
            <span>{{ displayName(item.parent) }}</span>
          </p>
          <p class="time-line" *ngIf="item.collectedAt">
            <mat-icon>check_circle</mat-icon>
            <span>{{ formatTime(item.collectedAt) }}</span>
          </p>
        </article>
      </div>
      <ng-template #emptyCollected>
        <div class="empty-state">{{ 'PICKUP.EMPTY_COLLECTED' | translate }}</div>
      </ng-template>
    </section>
  </div>

  <div class="modal-backdrop" *ngIf="showCollectConfirm" (click)="onCollectConfirm(false)">
    <div class="modal-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'PICKUP.COLLECT_CONFIRM_TITLE' | translate }}</h3>
      </div>
      <div class="modal-body">
        <p>{{ 'PICKUP.COLLECT_CONFIRM_BODY' | translate: { name: pendingCollectName } }}</p>
      </div>
      <div class="modal-footer collect-confirm-footer">
        <button
          type="button"
          class="btn collect-cancel-btn"
          (click)="onCollectConfirm(false)"
          [disabled]="collecting"
        >
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="btn collect-confirm-btn"
          (click)="onCollectConfirm(true)"
          [disabled]="collecting"
        >
          {{ (collecting ? 'PICKUP.COLLECT_WORKING' : 'PICKUP.COLLECT_CONFIRM') | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
